<script setup lang="ts">
import { RouterLink, RouterView, useRouter, useRoute } from 'vue-router'
import { ref, onMounted, getCurrentInstance, watch } from 'vue'
import { useUserInfoStore } from '@/stores/userInfo'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import Login from '@/components/Login/index.vue'
import AnnouncementDialog from '@/components/Liuyao/AnnouncementDialog/index.vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { restoreFromPayment } from '@/utils/sessionStorageManager'
import ActivityDialog from '@/components/Common/ActivityDialog/index.vue'
const currentInstance = getCurrentInstance()
const { $api } = currentInstance!.appContext.config.globalProperties
const activityFetchUrl = import.meta.env.VITE_BASE_URL_API + '/company/getActivityContent'

// 用户信息
const userInfoStore: any = useUserInfoStore()

const router = useRouter()
const route = useRoute()
const active = ref(0)
const showAnnouncementDialog = ref(false)
const showActivityDialog = ref(false)
// 'question', 'shake', 'history'
// let includeCache = ref(['history'])
function handleClick(activeNum: number) {
  if (activeNum == 0) {
    router.push('/')
  } else if (activeNum == 1) {
    router.push('/mine')
  }
}
router.beforeEach((to, from) => {
  // console.log(to.name, from.name)
  // if (to.name == 'history' && from.name != 'answer') {
  //   for (let i = 0; i < includeCache.value.length; i++) {
  //     if (includeCache.value[i] == 'history') {
  //       console.log('haha')
  //       includeCache.value.splice(i, 1)
  //       break
  //     }
  //   }
  // } else if (to.name == 'history') {
  //   includeCache.value.push('history')
  // }

  if (to.name == 'home') {
    active.value = 0
  } else if (to.name == 'mine') {
    active.value = 1
  } else {
    active.value = -1
  }
})

// 獲取用戶設備ID
const getDeviceId = async () => {
  const fp = await FingerprintJS.load()
  const result = await fp.get()
  const deviceId = result?.visitorId

  // userInfoStore.setUserInfo({
  //   deviceId,
  // })

  return deviceId
}
const showFeadback = ref(false)
const feebackText = ref('')
// 公告数据
const announcements: any = ref([])
const handleShowFeedBack = () => {
  showFeadback.value = true
}
const handleCloseFeedback = () => {
  showFeadback.value = false
}
const feedbackDialog = ref(false)
const handlefeedbackShow = () => {
  feedbackDialog.value = true
}
const handleCloseFeeedbackDialog = () => {
  feebackText.value = ''
  feedbackDialog.value = false
}

const copyWechatId = () => {
  const wechatId = 'yinghuohaihai'
  if (navigator.clipboard && window.isSecureContext) {
    // 现代浏览器的 Clipboard API
    navigator.clipboard.writeText(wechatId).then(() => {
      ElMessage.success('微信号已复制到剪贴板')
    }).catch(() => {
      ElMessage.error('复制失败，请手动复制')
    })
  } else {
    // 兼容性方案
    const textArea = document.createElement('textarea')
    textArea.value = wechatId
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    try {
      document.execCommand('copy')
      ElMessage.success('微信号已复制到剪贴板')
    } catch (err) {
      ElMessage.error('复制失败，请手动复制')
    }
    document.body.removeChild(textArea)
  }
}

const handleFeedbackSubmit = () => {
  if (feebackText.value == '' || feebackText.value == null) {
    ElMessage.error('请输入您的问题或建议')
    return
  }
  $api({
    url: import.meta.env.VITE_BASE_URL_API + '/company/feedback',
    method: 'post',
    headers: {
      'tianji-token': userInfoStore?.userInfo?.token,
    },
    data: {
      feedback: feebackText.value,
    },
  })
    .then((res: any) => {
      // console.log(res)
      if (res.data.code == 0) {
        ElMessage.success('感谢您的反馈，我们会认真处理您的意见')
      } else {
        ElMessage.error(res.data.errorMsg)
      }

      handleCloseFeeedbackDialog()
    })
    .catch((e: any) => { })
}

const getNotification = () => {
  $api({
    url: import.meta.env.VITE_BASE_URL_API + '/company/getNotification',
    method: 'GET',
    headers: {
      'tianji-token': userInfoStore?.userInfo?.token,
    },
  }).then(async (res: any) => {
    if (res.data.code === 0) {
      announcements.value = [res.data.data]
      if (res.data.data.autoPop === 1 && userInfoStore?.userInfo?.token) {
        handleShowNotice()
      }
    }
  })
}
// const handleGoArchiveList=()=>{
//   router.push('archiveList')
// }


// watch(()=>userInfoStore?.userInfo?.token,()=>{
//   if(userInfoStore?.userInfo?.token){
//     getDefaultArchives()
//   }else{
//     clearArchive( )
//   }
// },{
//     immediate: true,
//   })

// 跳转功能
const handleGoBack = (path: string) => {
  router.replace(path)
}

// 登录功能
const showModal = ref(false)
const handleLogin = () => {
  showModal.value = true
}
const getQueryParam = (param: any) => {
  const regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(window.location.href)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

const handleShowNotice = () => {
  showAnnouncementDialog.value = true
}

onMounted(async () => {
  // 检查是否是支付返回，如果是则恢复 sessionStorage
  const isPaymentReturn = restoreFromPayment()

  // 如果不是支付返回，才清除所有sessionStorage
  if (!isPaymentReturn) {
    sessionStorage.clear()
  }

  // 通过分享链接获取结果
  const source = getQueryParam('source')
  const token = getQueryParam('token')
  getNotification()
  if (token && source === 'help') {
    const deviceId = await getDeviceId()

    $api({
      url:
        import.meta.env.VITE_BASE_URL_API +
        `/userInfo/clickShareLink?token=${token}`,
      method: 'GET',
      headers: {
        'tianji-deviceId': deviceId,
      },
    }).then((res: any) => {
      if (String(res?.data?.code) === String(0)) {
        ElMessage.success(res.data.data)
      } else {
        ElMessage.error(res.data.errorMsg)
      }
    })
  }

  // 如果有token，則检查用户状态是否过期，如果沒有token，獲取設備ID並存儲
  if (userInfoStore?.userInfo?.token) {
    $api({
      url: import.meta.env.VITE_BASE_URL_API + '/userInfo/getUserInfo',
      method: 'GET',
      headers: {
        'tianji-token': userInfoStore?.userInfo?.token,
      },
    }).then(async (res: any) => {
      const deviceId = await getDeviceId()

      if (String(res?.data?.code) === String(0)) {
        userInfoStore.setUserInfo({
          ...(res?.data?.data || {}),
          token: userInfoStore?.userInfo?.token,
          deviceId,
        })

      } else {
        ElMessage.error(res.data.errorMsg)
        userInfoStore.setUserInfo({
          deviceId,
        })
      }
    })


  } else {
    const deviceId = await getDeviceId()

    userInfoStore.setUserInfo({
      deviceId,
    })
  }
})
</script>

<template>
  <el-config-provider :locale="zhCn">
    <div class="app-container">
      <div class="header" v-show="$route.meta.show">
        <span text @click="handleGoBack('/')">首页</span>
        <div class="rightHeader">
          <!-- <span text
              @click="handleGoArchiveList">档案</span> -->
          <span class="hot-activity-btn" @click="showActivityDialog = true">赢积分</span>
          <span class="feedback-btn" @click="handlefeedbackShow">反馈</span>
          <span text @click="handleShowNotice">公告</span>
          <span text v-if="!userInfoStore?.userInfo?.token" @click="handleLogin">登录/注册</span>
          <span text v-else @click="router.push('/mine')">我的</span>
        </div>
      </div>
      <div class="main-container">
        <div class="bottom-navigation" v-show="active > -1">
          <div class="mask"></div>
          <div class="bottom-navigation-content">
            <div class="bottom-navigation-item" @click="handleClick(0)">
              <img src="./assets/img/index.png" :class="active == 0 ? '' : 'hidden'" />
              <img src="./assets/img/index_grey.png" :class="active == 0 ? 'hidden' : ''" />
              <span>首页</span>
            </div>
            <div class="bottom-navigation-item" @click="handleClick(1)">
              <img src="./assets/img/mine.png" :class="active == 1 ? '' : 'hidden'" />
              <img src="./assets/img/mine_grey.png" :class="active == 1 ? 'hidden' : ''" />
              <span>我的</span>
            </div>
          </div>
        </div>

        <router-view v-slot="{ Component }">
          <!-- <keep-alive>  :include="includeCache"  -->
          <component :is="Component" />
          <!-- </keep-alive> -->
        </router-view>
      </div>

      <div class="footer-container">
        <div>
          <span class="feedbackBtn" @click="handleShowFeedBack">联系我们</span>
        </div>
        <div class="footer-content">
          <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2024102726号</a>
          <!-- <a  rel="noreferrer" target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502054703">
          <span>京公网安备11010502054703号</span>
        </a> -->
          <span>Copyright © 2024-2026 </span>
        </div>

        <!-- 北京醉慕替科技有限责任公司 -->
      </div>
      <div class="footer" :class="showFeadback ? 'showFeadback' : ''">
        <div>
          <!-- <div class="feedbackBtn" @click="handleShowFeedBack">反馈</div> -->
          <div class="feedbackText">
            我们的团队致力于不断优化AI解卦的表现，但请您理解技术的局限性，并给予反馈帮助我们改进服务。如您发现任何bug或者有任何关于产品的建议，请随时通过邮箱[support@tianji.online]联系我们的支持团队，或点击<span
              class="feedbackEntrance" @click="handlefeedbackShow">此处</span>直接反馈。
          </div>
          <div class="feedbackcloose" @click="handleCloseFeedback" v-show="showFeadback"></div>
        </div>
      </div>
    </div>

    <Login :showModal="showModal" @update:showModal="showModal = $event" />
    <ActivityDialog v-model="showActivityDialog" :fetch-url="activityFetchUrl" title="赢积分活动" />
    <el-dialog v-model="feedbackDialog" title="问题反馈" width="320px" :before-close="handleCloseFeeedbackDialog"
      class="feedback-dialog" center>
      <div class="feedback-content">
        <p class="feedback-description">
          遇到问题或有改进建议？我们很乐意听取您的意见，帮助我们为您提供更好的服务。（如您未登录请留下联系方式，方便我们联系到您）
        </p>
        <el-input v-model="feebackText" type="textarea" maxlength="200" :rows="4" placeholder="请详细描述您遇到的问题或建议..."
          class="feedback-input" show-word-limit />
      </div>
      <template #footer>
        <div class="feedback-footer">
          <el-button @click="handleCloseFeeedbackDialog" class="cancel-btn">取消</el-button>
          <el-button type="primary" @click="handleFeedbackSubmit" class="submit-btn">
            提交反馈
          </el-button>
        </div>
        <div class="customer-service-info">
          <span>客服微信号：yinghuohaihai</span>
          <el-button size="small" type="text" @click="copyWechatId" class="copy-btn">
            复制
          </el-button>
        </div>
      </template>
    </el-dialog>
    <AnnouncementDialog v-model="showAnnouncementDialog" :announcements="announcements" />
    <el-backtop :right="12" :bottom="20" />
  </el-config-provider>
</template>

<style lang="scss">
.header {
  background-color: #2b3440e8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  color: #ddd;
  width: 100%;
  position: fixed;
  z-index: 99;
  backdrop-filter: blur(30px);
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;

  button:hover {
    background: none !important;
  }

  .rightHeader {
    display: flex;
    justify-content: space-between;
    flex: 0 0 auto;
    gap: 1rem;
    align-items: center;
    white-space: nowrap;

    .hot-activity-btn {
      background: radial-gradient(circle at 30% 30%, #ffa930 0%, rgba(255, 236, 210, 0.6) 25%, transparent 55%),
        linear-gradient(135deg, #ff7a18, #ff3d00);
      color: white;
      padding: 4px 8px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: bold;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 2px 6px rgba(255, 61, 0, 0.35), 0 0 8px rgba(255, 122, 24, 0.35);
      position: relative;

      &::before {
        content: '🔥';
        margin-right: 4px;
      }

      &:hover {
        transform: translateY(-1px) scale(1.02);
        box-shadow: 0 4px 12px rgba(255, 61, 0, 0.45), 0 0 12px rgba(255, 122, 24, 0.45);
      }
    }

    .feedback-btn {
      background: linear-gradient(135deg, #4a90e2, #357abd);
      color: white;
      padding: 4px 8px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: bold;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 2px 6px rgba(74, 144, 226, 0.3);

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(74, 144, 226, 0.4);
      }
    }
  }
}

.feedbackBtn {
  text-decoration: underline;
}

.feedbackText {
  background-image: linear-gradient(183deg, #2a3442, #454d58);
  height: 110px;
  font-size: 12px;
  color: #ffffff;
  padding: 10px 10px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  position: relative;
}

.showFeadback {
  bottom: 0 !important;
}

.footer {
  position: fixed;
  bottom: -110px;
  left: 0;
  right: 0;
  z-index: 150;
  transition: all 1s;
}

.feedbackEntrance {
  color: #f6ff55;
  cursor: pointer;
  text-decoration: underline;
}

.feedbackcloose {
  height: 10px;
  width: 10px;
  border: #ebf65d solid;
  z-index: 200;
  position: absolute;
  bottom: 17px;
  left: 50%;
  border-width: 3px 3px 0 0;
  transform: rotate(135deg) translateX(5px);
  animation: feedbackCloseBtnAnimation 1.5s infinite;
}

@keyframes feedbackCloseBtnAnimation {
  0% {
    bottom: 17px;
  }

  50% {
    bottom: 13px;
  }

  100% {
    bottom: 17px;
  }
}

.el-dialog__title {
  font-size: 16px;
}

.el-dialog__headerbtn {
  top: 6px;
}

.el-dialog__footer {
  text-align: center;
}

// 反馈对话框样式
.feedback-dialog {
  .el-dialog {
    background: transparent !important;
    box-shadow: none !important;
  }

  .el-dialog__wrapper {
    background: transparent !important;
  }

  .el-dialog__header {
    background: linear-gradient(135deg, #4a90e2, #357abd);
    color: white;
    padding: 20px 24px 16px;
    border-radius: 8px 8px 0 0;

    .el-dialog__title {
      color: white;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__headerbtn {
      top: 16px;
      right: 16px;

      .el-dialog__close {
        color: white;
        font-size: 18px;

        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }

  .el-dialog__body {
    padding: 16px;
    background: #fafbfc;
  }

  .el-dialog__footer {
    background: #fafbfc;
    padding: 0;
    border-radius: 0 0 8px 8px;
  }
}

// 全局覆盖反馈对话框样式
.el-dialog.feedback-dialog {
  background: transparent !important;
  box-shadow: none !important;
}

.el-dialog__wrapper .feedback-dialog {
  background: transparent !important;
}

.feedback-content {
  .feedback-description {
    color: #666;
    font-size: 14px;
    line-height: 1.6;
    margin: 0 0 16px 0;
    padding: 12px;
    background: #e8f4fd;
    border-radius: 6px;
    border-left: 4px solid #4a90e2;
  }

  .feedback-input {
    .el-textarea__inner {
      border: 2px solid #e1e6eb;
      border-radius: 8px;
      padding: 12px;
      font-size: 14px;
      line-height: 1.5;
      resize: none;
      transition: all 0.3s ease;

      &:focus {
        border-color: #4a90e2;
        box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
      }

      &::placeholder {
        color: #aaa;
      }
    }
  }
}

.feedback-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 0px;
  padding: 8px 24px;

  .cancel-btn {
    padding: 10px 20px;
    border: 1px solid #ddd;
    background: white;
    color: #666;
    border-radius: 6px;
    font-size: 14px;

    &:hover {
      background: #f5f5f5;
      border-color: #bbb;
    }
  }

  .submit-btn {
    padding: 10px 24px;
    background: linear-gradient(135deg, #4a90e2, #357abd);
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;

    &:hover {
      background: linear-gradient(135deg, #357abd, #2968a3);
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
    }
  }
}

.customer-service-info {
  text-align: center;
  color: #888;
  font-size: 12px;
  padding: 12px 24px 16px 24px;
  border-top: 1px solid #eee;
  margin-top: 0px;
  background: #fafbfc;
  border-radius: 0 0 8px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .copy-btn {
    color: #4a90e2;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 2px 6px;
    border-radius: 4px;

    &:hover {
      color: #357abd;
      background-color: rgba(74, 144, 226, 0.1);
    }
  }
}

.bottom-navigation {
  display: none;

  height: 3.8rem;
  width: 80%;
  position: fixed;
  bottom: 15px;
  left: 0;
  right: 0;
  font-size: 0.9rem;
  border-radius: 2rem;
  z-index: 100;
  color: #ffffff;
  margin: 0 auto;

  .mask {
    background: black;
    opacity: 0.32;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border-radius: 2rem;
    z-index: 1;
  }

  .bottom-navigation-content {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 2;
    padding: 0 16px;
  }

  .bottom-navigation-item {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      height: 1.6rem;
    }
  }
}

div {
  box-sizing: border-box;
}

#app {
  background: #dad7d7;
  height: 100vh;
  width: 100vw;
  /* font-size: 100px; */
}

.container {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  /* padding: 1rem 0; */
  box-sizing: border-box;
  background: #dad7d7;
  position: relative;
  /* overflow: hidden; */
}

.page {
  position: relative;
  z-index: 10;
  width: 100%;
  padding: 10px;
}

.block {
  box-shadow: 0rem 1rem 1rem 0rem rgba(0, 0, 0, 0.25);
  background: #f0f0f0;
  border-radius: 1rem;
  padding: 1rem 0.5rem;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  color: #333;
  border: none;
}

.btn-box {
  /* margin-top: 4rem; */
  text-align: center;
}

.btn {
  background: #f0f0f0;
  border-radius: 4rem;
  color: #000000;
  font-size: 1.3rem;
  height: 3rem;
  line-height: 3rem;
  box-shadow: 0rem 0.1rem 0.7rem 0.1rem rgba(0, 0, 0, 0.25);
  padding: 0 1.3rem;
  width: 10rem;
}

button:disabled {
  color: #999;
}

.bg {
  position: fixed;
  bottom: 14rem;
  width: 100%;
}

.hidden {
  display: none;
}

/* @media (min-width: 1024rem) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }
} */

.app-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  position: relative;
  // overflow-y: auto;
  background: #dad7d7;
}

.main-container {
  width: 100%;
  // height: 100%;
  // padding-bottom: 12rem;
  padding-top: 48px;
}

.footer-container {
  width: 100%;
  grid-auto-flow: row;
  // column-gap: 1rem;
  row-gap: 0.3rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  // background-color: rgb(43 52 64);
  background-color: rgb(66 72 80);
  display: grid;
  padding: 1.7rem 0;
  text-align: center;
  color: #999;
}

.footer-content {
  display: flex;
  // flex-direction: column;
  justify-content: center;
  align-items: center;

  span {
    margin-left: 0.8rem;
  }
}

.text-color {
  color: #9ca3af;
}

.el-page-header {
  background-color: #2b3440e8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  color: #ddd;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 99;
  backdrop-filter: blur(30px);
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;

  .el-page-header__header {
    width: 100%;
  }

  .el-page-header__content {
    color: #ddd;
  }

  .el-divider {
    display: none;
  }
}
</style>
